import { Drawer } from '@mui/material';
import CustomDrawer from './CustomDrawer';
import * as Constants from "../utils/constants";

const drawerWidth = Constants.DRAWER_WIDTH;

const SideDrawer = () => {
  return (
    <Drawer
      variant="permanent"
      PaperProps={{ elevation: 10 }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          boxSizing: 'border-box',
          width: drawerWidth,
          overflowX: 'hidden',
        },
      }}
      open
    >
      <CustomDrawer />
    </Drawer>
  );
};

export default SideDrawer;
